// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Режим вида ячеек «Changes over 30 days» (Зміни за 30 днів) — бэк T7 / T8 (ночной снимок audit.report_cell_daily → hist_val).
// Спутник ячейки-даты (§1.2): hist_val = [[день 'YYYY-MM-DD', { мера: значение }], …] — только дни изменений, по возрастанию (первый — самый старый), ≤ 31 точки.
// Круг по max за 30 дней: layersOf → sizeValue (cellRing_build opts.sizeValue), value = текущее (без ложного over-100 — шкала группы считает max по ячейкам).
// Слои «огибающей»: текущее — самое тёмное ('solid'); дальше от новых дней к старым — на сколько значение дня было выше всех более новых, тоном
// 'light-1' … 'light-5' по возрасту (ступень — 6 дней от опорного дня: ctx.today или последний день истории). Подсказка — список «день — значение».
// «Снимков ещё нет» (stats.delta_30d === 'no snapshot', stats — doc.cell_views_stats, ctx.stats) — круга нет, ячейка показывает число,
// подсказка emptyNoteOf → «Snapshots not taken yet».
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): реализация (была заглушка T1). Тесты — tests/unit/cellViewDelta30d.test.mjs
import { t as tI18n } from '@/i18n'
import { cellRing_tone } from '@/utils/cellRing'

export const DELTA_30D_VIEW = 'delta_30d'
export const DELTA_30D_COLOR = '#3949ab'
export const DELTA_30D_NO_SNAPSHOT = 'no snapshot'
const AGE_STEP_DAYS = 6   // 30 дней / 5 ступеней light-N
const DAY_MS = 86400000

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))
const dayMs = (d) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str(d)); return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : NaN }

// снимков ещё нет: stats (объект или список объектов статистики: основной ответ и отложенный) с delta_30d === 'no snapshot'
export function delta30d_noSnapshot(stats) {
    const list = Array.isArray(stats) ? stats : [stats]
    return list.some(s => isObj(s) && str(s.delta_30d).toLowerCase() === DELTA_30D_NO_SNAPSHOT)
}

// точки истории меры: hist_val → [{ day, value }] по возрастанию дня (без чисел и без меры — пропуск) | null (спутника нет)
export function delta30d_points(histVal, measure) {
    if (!Array.isArray(histVal)) return null
    const ms = str(measure)
    const out = []
    for (const p of histVal) {
        if (!Array.isArray(p) || p.length < 2 || !isObj(p[1])) continue
        const day = str(p[0])
        if (!day || !isNum(p[1][ms])) continue
        out.push({ day, value: Number(p[1][ms]) })
    }
    out.sort((a, b) => (a.day < b.day ? -1 : (a.day > b.day ? 1 : 0)))
    return out
}

// тон дня по возрасту от опорного дня: 'light-1' (0…6 дней) … 'light-5' (25+ дней)
export function delta30d_tone(day, refDay) {
    const a = dayMs(day), r = dayMs(refDay)
    const age = Number.isFinite(a) && Number.isFinite(r) ? Math.max(0, Math.round((r - a) / DAY_MS)) : 0
    return 'light-' + Math.min(5, Math.max(1, Math.ceil(age / AGE_STEP_DAYS)))
}

// слои огибающей: cur — текущее значение ячейки (нет — последнее в истории), points — delta30d_points, refDay — опорный день
// → { layers, sizeValue, value, points, refDay } | null
export function delta30d_layers(cur, points, refDay, t = tI18n) {
    if (!Array.isArray(points)) return null
    const tt = typeof t === 'function' ? t : (x) => x
    const last = points.length ? points[points.length - 1] : null
    const c = isNum(cur) ? Number(cur) : (last ? last.value : 0)
    const ref = str(refDay) || (last ? last.day : '')
    let covered = Math.abs(c)
    const layers = [{ key: 'current', title: tt('Current'), value: covered, color: DELTA_30D_COLOR, tone: 'solid' }]
    for (let i = points.length - 1; i >= 0; i--) {
        const v = Math.abs(points[i].value)
        if (!(v > covered)) continue
        layers.push({ key: points[i].day, title: points[i].day, value: v - covered, color: DELTA_30D_COLOR, tone: delta30d_tone(points[i].day, ref) })
        covered = v
    }
    return { layers, sizeValue: covered, value: c, points, refDay: ref }
}

export default {
    key: DELTA_30D_VIEW,
    title: 'Changes over 30 days',
    satellites: ['hist_val'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value, stats? (doc.cell_views_stats | [основная, отложенная]), today? ('YYYY-MM-DD') }
    layersOf(dataItem, binding, ctx = {}) {
        if (delta30d_noSnapshot(ctx.stats)) return null
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const points = delta30d_points(cell.hist_val, ctx.measure)
        const res = delta30d_layers(ctx.value, points, ctx.today, ctx.t || tI18n)
        return res ? { ...res, satellite: 'hist_val' } : null
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        const max = Math.abs(Number(res && res.sizeValue)) || 0
        const share = (v) => (max > 0 ? Math.abs(v) / max : 0)
        const rows = [{ title: t('Current'), value: res ? res.value : 0, color: DELTA_30D_COLOR, share: share(res ? res.value : 0) }]
        const pts = Array.isArray(res && res.points) ? res.points : []
        for (let i = pts.length - 1; i >= 0; i--) {
            const p = pts[i]
            rows.push({ title: p.day, value: p.value, color: cellRing_tone(DELTA_30D_COLOR, delta30d_tone(p.day, res.refDay)), share: share(p.value) })
        }
        const note = pts.length ? [] : [t('No changes in 30 days')]
        return { caption: t('Values over 30 days'), rows, note }
    },
    // подсказка ячейки без круга: снимков ещё нет
    emptyNoteOf(ctx = {}) {
        const t = ctx.t || tI18n
        return delta30d_noSnapshot(ctx.stats) ? t('Snapshots not taken yet') : ''
    },
    cacheKey(dataItem, ctx = {}) {
        const c = ctx.cell
        const h = isObj(c) && Array.isArray(c.hist_val) ? c.hist_val : null
        const last = h && h.length ? str(Array.isArray(h[h.length - 1]) ? h[h.length - 1][0] : '') : ''
        return `${delta30d_noSnapshot(ctx.stats) ? 'ns' : ''}|${h ? h.length : '-'}|${last}`
    },
}
